import { CustomElement } from '@aurelia/runtime-html';
export const name = "tooltip-component";
export const template = "<i id=\"${tooltipId}\" class=\"text-secondary-900 dark:text-secondary-100 text-base mdi mdi-help-circle-outline s\"></i>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
